import React from 'react';
import styles from './TabToolsContainer.module.scss';

const TabToolsContainer = ({ children }) => {
  return (
    <div className={styles.toolsContainer}>
      {children}
    </div>
  );
};

export default TabToolsContainer;
